import React, { useState, useEffect } from 'react';
import { setAsArray } from '../../../../util/utilfunctions/utilFunctions';
import RegistrationInput from '../../../UI/Registration/RegistrationInput';
import RegistrationInput2 from '../../../UI/Registration/RegistrationInput2';
import RegistrationSelect from '../../../UI/Registration/RegistrationSelect';
import { stateData } from '../../../../constants/countrylist';

const MoneyGramReceiverFields = ({ receiverFields, formValues, formErrors, countries, transactionDetails, setTransactionDetails,stateProvinceInfo = [] }) => {
    const knownSelectFields = ['receiverCountry', 'receiverState', 'receiverNationality', 'destinationState', 'senderCountry', 'senderState', 'senderCitizenshipCountry', 'senderBirthCountry', 'senderCitizenshipAtBirthCountry', 'senderDualCitizenshipCountry', 'senderLegalIdIssueCountry', 'senderPhotoIdCountry', 'senderIntendedUseOfMGIServices', 'sendPurposeOfTransaction'];
    const allowedComplianceFields = [ 'sendPurposeOfTransaction', 'senderIntendedUseOfMGIServices'];
    const [stateOptions, setStateOptions] = useState([{ key: 'not-available', value: 'not-available', label: 'Not Available' }]);
    const [senderStateOptions, setSenderStateOptions] = useState([{ key: 'not-available', value: 'not-available', label: 'Not Available' }]);

    console.log('formValues inside receiver field', formValues);

    const receiverCountryCode = (
  transactionDetails?.receiverCountry ||
  transactionDetails?.receivercountry ||
  ''
).toUpperCase().trim();

    const USA_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA",
  "HI","ID","IL","IN","IA","KS","KY","LA","ME","MD",
  "MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ",
  "NM","NY","NC","ND","OH","OK","OR","PA","RI","SC",
  "SD","TN","TX","UT","VT","VA","WA","WV","WI","WY",
  "DC"  // Washington D.C. — often supported
];

const CAN_PROVINCES = [
  "AB","BC","MB","NB","NL","NS","NT","NU","ON","PE",
  "QC","SK","YT"
];

const usaNames = {
  "AL": "Alabama", "AK": "Alaska", "AZ": "Arizona", "AR": "Arkansas", "CA": "California",
  "CO": "Colorado", "CT": "Connecticut", "DE": "Delaware", "FL": "Florida", "GA": "Georgia",
  "HI": "Hawaii", "ID": "Idaho", "IL": "Illinois", "IN": "Indiana", "IA": "Iowa",
  "KS": "Kansas", "KY": "Kentucky", "LA": "Louisiana", "ME": "Maine", "MD": "Maryland",
  "MA": "Massachusetts", "MI": "Michigan", "MN": "Minnesota", "MS": "Mississippi", "MO": "Missouri",
  "MT": "Montana", "NE": "Nebraska", "NV": "Nevada", "NH": "New Hampshire", "NJ": "New Jersey",
  "NM": "New Mexico", "NY": "New York", "NC": "North Carolina", "ND": "North Dakota", "OH": "Ohio",
  "OK": "Oklahoma", "OR": "Oregon", "PA": "Pennsylvania", "RI": "Rhode Island", "SC": "South Carolina",
  "SD": "South Dakota", "TN": "Tennessee", "TX": "Texas", "UT": "Utah", "VT": "Vermont",
  "VA": "Virginia", "WA": "Washington", "WV": "West Virginia", "WI": "Wisconsin", "WY": "Wyoming",
  "DC": "District of Columbia"
};

const canNames = {
  "AB": "Alberta", "BC": "British Columbia", "MB": "Manitoba", "NB": "New Brunswick",
  "NL": "Newfoundland and Labrador", "NS": "Nova Scotia", "NT": "Northwest Territories",
  "NU": "Nunavut", "ON": "Ontario", "PE": "Prince Edward Island", "QC": "Quebec",
  "SK": "Saskatchewan", "YT": "Yukon"
};

    const shouldShowDestinationState = () => {
  const sender = (transactionDetails?.senderCountry || formValues?.countryid || '').toUpperCase().trim();
  const receiver = (transactionDetails?.receiverCountry || transactionDetails?.receivercountry || formValues?.receivercountry || '').toUpperCase().trim();

  return ["USA", "JAM"].includes(sender) && ["USA", "CAN"].includes(receiver);
};

   const getReceiverMGStateOptions = () => {
  const receiverCountryCode = (
    transactionDetails?.receiverCountry ||
    transactionDetails?.receivercountry ||
    ''
  ).toUpperCase().trim();

  if (!receiverCountryCode || !stateProvinceInfo.length) {
    return [];
  }

  const filtered = stateProvinceInfo.filter(
    item => (item["ac:countryCode"] || '').toUpperCase().trim() === receiverCountryCode
  );

  console.log(`%c RECEIVER STATES FOR ${receiverCountryCode} (${filtered.length} entries)`,
    "background: blue; color: white; font-weight: bold");
  console.table(
    filtered.map(item => ({
      countryCode: item["ac:countryCode"],
      stateProvinceCode: item["ac:stateProvinceCode"],
      stateProvinceName: item["ac:stateProvinceName"],
    }))
  );

  return filtered.map(item => ({
    key: item["ac:stateProvinceCode"],
    value: item["ac:stateProvinceCode"],
    label: item["ac:stateProvinceName"] || item["ac:stateProvinceCode"],  // Fallback to code if no name
  }));
};

   const getDestinationStateOptions = () => {
  if (!shouldShowDestinationState()) return [];

  let codes = [];
  if (receiverCountryCode === "USA") {
    codes = USA_STATES;
  } else if (receiverCountryCode === "CAN") {
    codes = CAN_PROVINCES;
  }

  return codes.map(code => ({
    key: code,
    value: code,
    label: `${getFullStateName(code, receiverCountryCode)}`
  }));
};

// Optional: if you want full names in the dropdown (recommended for UX)
        const getFullStateName = (code, receiverCode) => {
  if (receiverCode === "USA") return usaNames[code] || code;
  if (receiverCode === "CAN") return canNames[code] || code;
  return code;
};

    // Parse extendedfields from formValues
    const parseExtendedFields = (extendedFields) => {
        try {
            // Replace encoded quotes
            const cleanedFields = extendedFields.replace(/&amp;quot;/g, '"');
            return JSON.parse(cleanedFields);
        } catch (error) {
            console.error('Error parsing extendedfields:', error);
            return {};
        }
    };

    // Prefill sender fields from formValues
    useEffect(() => {
        const extendedFields = formValues.extendedfields ? parseExtendedFields(formValues.extendedfields) : {};

        const senderFieldMappings = {
    senderFirstName: formValues.firstName || '',
    senderLastName: formValues.lastName || '',
    senderMiddleName: formValues.otherNames || '',
    senderAddress: formValues.address1 || '',
    senderAddress2: formValues.address2 || '',
    senderCity: formValues.cityname || '',
    senderCountry: formValues.countryid || '',
    senderState: formValues.stateid || '',
    senderZipCode: formValues.zip || '',
    senderHomePhone: formValues.telephoneno || '',
    senderHomePhoneCountryCode: formValues.telephonenocountrycode || '',
    senderEmailAddress: formValues.email || '',
    senderDOB: formValues.dateofbirth || '',
    // senderOccupation: formValues.occupation || extendedFields.occupation || '',
    senderGender: formValues.gender || '',
    senderCitizenshipCountry: formValues.nationalitycountry || extendedFields.citizenshipcountry || '',
    senderBirthCity: extendedFields.placeofbirth || '',
    senderBirthCountry: extendedFields.birthcountry || '',
    senderBirthState: extendedFields.birthstate || '',
    senderCitizenshipAtBirthCountry: extendedFields.citizenshipatbirthcountry || '',
    senderLegalIdType: extendedFields.legalidtype || '',
    senderLegalIdNumber: extendedFields.legalidnumber || '',
    // sourceOfFunds: extendedFields.sourceoffunds || '',
    sendPurposeOfTransaction: extendedFields.purposeoftransaction || '',
    senderIntendedUseOfMGIServices: extendedFields.intendeduseofmgiservices || '',
};

        // Split legalidexpdate into day, month, year if available
        if (extendedFields.legalidexpdate && extendedFields.legalidexpdate !== 'null') {
    const [year, month, day] = extendedFields.legalidexpdate.split('-');
    senderFieldMappings.senderLegalIdExpirationYear = year || '';
    senderFieldMappings.senderLegalIdExpirationMonth = month || '';
    senderFieldMappings.senderLegalIdExpirationDay = day || '';
}

        // Update transactionDetails with sender fields
        Object.entries(senderFieldMappings).forEach(([key, value]) => {
            if (value && !transactionDetails[key]) {
                setTransactionDetails(key, value);
            }
        });
    }, [formValues, setTransactionDetails]);

    // Update state options for receiverState
    useEffect(() => {
        const updateReceiverStates = () => {
            const country = transactionDetails.receiverCountry;
            if (!country || country === 'na') {
                setStateOptions([{ key: 'not-available', value: 'not-available', label: 'Not Available' }]);
                return;
            }

            const countryInfo = stateData.find((c) => c.iso3 === country);
            const states = countryInfo?.states || [];
            const mapped = states.length
                ? states.map((s) => ({ key: s.state_code, value: s.state_code, label: s.name }))
                : [{ key: 'not-available', value: 'not-available', label: 'Not Available' }];

            setStateOptions(mapped);
        };

        updateReceiverStates();
    }, [transactionDetails.receiverCountry]);

    // Update state options for senderState
    useEffect(() => {
        const updateSenderStates = () => {
            const country = transactionDetails.senderCountry || formValues.countryid;
            if (!country || country === 'na') {
                setSenderStateOptions([{ key: 'not-available', value: 'not-available', label: 'Not Available' }]);
                return;
            }

            const countryInfo = stateData.find((c) => c.iso3 === country);
            const states = countryInfo?.states || [];
            const mapped = states.length
                ? states.map((s) => ({ key: s.state_code, value: s.state_code, label: s.name }))
                : [{ key: 'not-available', value: 'not-available', label: 'Not Available' }];

            setSenderStateOptions(mapped);
        };

        updateSenderStates();
    }, [transactionDetails.senderCountry, formValues.countryid]);

    const reorderReceiverNameFields = (fields) => {
        const preferredOrder = [
            'receiverFirstName',
            'receiverFirstNameNotAvailable',
            'receiverMiddleName',
            'receiverLastName',
            'receiverLastName2',
            'receiverNameSuffix',
            'senderFirstName',
            'senderFirstNameNotAvailable',
            'senderMiddleName',
            'senderLastName',
            'senderLastName2',
            'senderNameSuffix',
        ];

        const nameFields = [];
        const otherFields = [];

        fields.forEach((field) => {
            if (preferredOrder.includes(field.xmlTag)) {
                nameFields.push(field);
            } else {
                otherFields.push(field);
            }
        });

        nameFields.sort((a, b) => preferredOrder.indexOf(a.xmlTag) - preferredOrder.indexOf(b.xmlTag));

        return [...nameFields, ...otherFields];
    };

    const orderedFields = reorderReceiverNameFields(receiverFields);

    return (
        <>

        
            {orderedFields.map((field) => {

                // Skip rendering fields with "NotAvailable" in xmlTag
                                if (field.xmlTag.includes('NotAvailable')) {
                                    return null;
                                }
                                    if (
                        field.fieldCategory !== 'Destination Information' &&
                        field.fieldCategory !== 'Partner Configuration' &&
                        field.fieldCategory !== 'Sender Information' &&
                        !allowedComplianceFields.includes(field.xmlTag)
                    ) {
                        return false;
                    }

                    

                const fieldName = field.xmlTag;
                const fieldLabel = field.fieldLabel || field.xmlTag;
                const fieldValue=transactionDetails[fieldName] || formValues[fieldName] || '';
                const hasError = formErrors[fieldName];

                const isRequired = field.visibility === 'REQ' || ['sendPurposeOfTransaction', 'senderIntendedUseOfMGIServices'].includes(field.xmlTag);
                const isEnumerated = field.enumerated === 'true';
                const isSelectField = knownSelectFields.includes(field.xmlTag) || isEnumerated;

                // ──── SPECIAL HANDLING FOR destinationState ──────────────────────
                    if (fieldName === "destinationState") {
                        if (!shouldShowDestinationState()) {
                        return null;
                        }

                        const options = getDestinationStateOptions();
                        const currentValue = (transactionDetails[fieldName] || '').toUpperCase().trim();

                        return (
                        <RegistrationSelect
                            key={fieldName}
                            label={
                            (transactionDetails?.receiverCountry || transactionDetails?.receivercountry || '')
                                .toUpperCase() === "CAN"
                                ? "Destination Province"
                                : "Destination State"
                            }
                            required={true}  // or: field.visibility === 'REQ'
                            value={currentValue}
                            hasError={!!formErrors[fieldName]}
                            options={options.length > 0 ? options : [{ key: "", value: "", label: "Select state/province" }]}
                            onChange={(e) => {
                            const code = (e.target.value || '').toUpperCase().trim();
                            setTransactionDetails(fieldName, code);
                            }}
                        />
                        );
                    }

                    if (fieldName === "receiverState") {
                                const mgOptions = getReceiverMGStateOptions();
                                if (mgOptions.length === 0) {
                                    console.log(`Skipping receiverState for country with no MG states: ${receiverCountryCode}`);
                                    return null;  
                                }

                                
                                return (
                                    <RegistrationSelect
                                    key={fieldName}
                                    label={fieldLabel}
                                    required={isRequired}
                                    value={fieldValue}
                                    hasError={hasError}
                                    options={mgOptions}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setTransactionDetails(fieldName, value);
                                    }}
                                    />
                                );
                                }

                if (isSelectField) {
                    const isCountry = [
                        'receiverCountry',
                        'receiverNationality',
                        'senderCountry',
                        'senderCitizenshipCountry',
                        'senderBirthCountry',
                        'senderCitizenshipAtBirthCountry',
                        'senderDualCitizenshipCountry',
                        'senderLegalIdIssueCountry',
                        'senderPhotoIdCountry',
                    ].includes(fieldName);

                    let enumeratedValues = [];
                    if (isEnumerated) {
                        enumeratedValues = setAsArray(field.enumeratedValues?.enumeratedValueInfo);
                        enumeratedValues = enumeratedValues.map((option) => ({
                            key: option.value,
                            value: option.value,
                            label: option.label,
                        }));
                    }

                    const options = isCountry
                        ? countries
                        : fieldName === 'receiverState'
                        ? stateOptions
                        : fieldName === 'senderState'
                        ? senderStateOptions
                        : enumeratedValues.length
                        ? enumeratedValues
                        : [];

                    return (
                        <RegistrationSelect
                            key={fieldName}
                            label={fieldLabel}
                            required={isRequired}
                            value={fieldValue}
                            hasError={hasError}
                            options={options}
                            onChange={(e) => {
                                const value = e.target.value;
                                setTransactionDetails(fieldName, value);
                            }}
                        />
                    );
                }
                return (
                    <RegistrationInput2
                        key={fieldName}
                        label={fieldLabel}
                        required={isRequired}
                        value={fieldValue}
                        hasError={hasError}
                        onChange={(e) => {
                            setTransactionDetails(fieldName, e.target.value);
                        }}
                        min={field.fieldMin || undefined}
                        max={field.fieldMax || undefined}
                    />
                );
            })}
        </>
    );
};

export default MoneyGramReceiverFields;
